import { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { Plus, ChevronRight, MessageSquare } from "lucide-react";
import { api, fmtDate, URGENCY, MODALITY } from "@/lib/api";
import { useAuth } from "@/context/AppContext";
import { useSeo } from "@/lib/draft";
import { Loading } from "@/App";

export const StageChip = ({ stage, label }) => {
  const color = { contratada: "bg-emerald-100 text-emerald-800", nao_assumida: "bg-slate-200 text-slate-700", encerrada: "bg-slate-200 text-slate-700",
    aguardando_info: "bg-amber-100 text-amber-800" }[stage] || "bg-[#EDF5FF] text-[#1465C8]";
  return <span className={`chip ${color}`} data-testid="stage-chip">{label}</span>;
};

export default function MinhasSolicitacoes() {
  useSeo("Minhas solicitações", null, true);
  const { user } = useAuth();
  const [items, setItems] = useState(null);
  const [unread, setUnread] = useState(0);
  useEffect(() => {
    api.get("/me/requests").then((r) => setItems(r.data)).catch(() => setItems([]));
    api.get("/me/unread").then((r) => setUnread(r.data.unread)).catch(() => {});
  }, []);
  if (user?.role === "admin") return <Navigate to="/admin" replace />;
  if (user?.role === "lawyer") return <Navigate to="/advogado" replace />;
  if (!items) return <Loading />;
  return (
    <div className="wrap max-w-4xl py-10">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="eyebrow">Olá, {user.name?.split(" ")[0]}</p>
          <h1 className="mt-1 text-3xl font-extrabold md:text-4xl">Minhas solicitações</h1>
        </div>
        <div className="flex gap-2">
          <Link to="/minha-conta" className="btn-secondary btn-sm" data-testid="my-account-link">Minha conta</Link>
          <Link to="/solicitar" className="btn-primary btn-sm" data-testid="my-new-request-btn"><Plus size={16} />Nova</Link>
        </div>
      </div>
      {unread > 0 && <p className="mt-6 flex items-center gap-2 rounded-xl bg-[#1465C8] p-4 text-white" data-testid="unread-banner"><MessageSquare size={18} />Você tem {unread} nova(s) mensagem(ns). Abra a solicitação para ler.</p>}
      {items.length === 0 ? (
        <div className="card mt-8 text-center" data-testid="my-requests-empty">
          <p className="text-[#64748B]">Você ainda não enviou solicitações.</p>
          <Link to="/solicitar" className="btn-primary mt-4">Iniciar solicitação</Link>
        </div>
      ) : (
        <ul className="mt-8 space-y-3" data-testid="my-requests-list">
          {items.map((r) => (
            <li key={r.request_id}>
              <Link to={`/minhas-solicitacoes/${r.request_id}`} className="select-card flex items-center justify-between gap-4" data-testid={`my-request-${r.protocol}`}>
                <div className="min-w-0">
                  <p className="font-mono text-sm font-bold text-[#1465C8]">{r.protocol}</p>
                  <p className="mt-1 truncate font-bold">{r.category_name}</p>
                  <p className="mt-1 text-xs text-[#64748B]">{MODALITY[r.modality]} · {URGENCY[r.urgency]} · {fmtDate(r.created_at)}</p>
                </div>
                <div className="flex shrink-0 items-center gap-2"><StageChip stage={r.stage} label={r.stage_label} /><ChevronRight size={18} className="text-[#64748B]" /></div>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
